import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import Immutable from 'immutable';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { Button } from '@bibliocommons/base-buttons';
import { Dropdown } from '@bibliocommons/base-dropdown';
import RatingStars from './RatingStars';

import './RatingControl.scss';

export class RatingControl extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getOptions() {
    const ratingOptions = Array(10)
      .fill(null)
      .map((_, rating) => {
        const ratingValue = (rating + 1) * 10;

        return Immutable.Map({
          key: `rating-dropdown-value-${rating + 1}`,
          selected: this.props.rating === ratingValue,
          value: ratingValue,
          label: this.props.intl.formatMessage({ id: 'rating_values' }, { rating: (rating + 1) * 0.5 })
        });
      });

    const noRating = Immutable.Map({
      key: 'rating-dropdown-no-rating',
      selected: !this.props.rating,
      value: 0,
      label: this.props.intl.formatMessage({ id: 'no_rating' })
    });

    return Immutable.List([noRating, ...ratingOptions]);
  }

  renderDropdownLabel() {
    const { rating, size } = this.props;
    const label = rating > 0 ? 'your_rating' : 'rate_this';
    const starsClass = cn('rating-control__rating-stars', {
      'rating-control__rating-stars--branded': rating > 0 && this.props.useLibraryBranding,
      'rating-control__rating-stars--generic': rating > 0 && !this.props.useLibraryBranding
    });

    return (
      <span className="rating-control__dropdown_label">
        <RatingStars
          className={starsClass}
          rating={rating}
          size={size}
          screenReaderLabel={<FormattedMessage id={`${label}_sr_label`} values={{ rating: rating / 20 }} />}
        />
        <span className="rating-control__label" aria-hidden>
          <FormattedMessage id={`${label}`} />
        </span>
      </span>
    );
  }

  render() {
    return (
      <div className={cn('cp-rating-control', this.props.className)}>
        <Dropdown
          selectable
          showLoadingText
          isLoading={this.props.isLoading}
          disabled={this.props.disabled}
          buttonTag={Button}
          dataKey="rating-dropdown"
          className="rating-dropdown"
          buttonClassName="rating-control__dropdown_button"
          renderLabel={this.renderDropdownLabel}
          options={this.getOptions()}
          handleSelect={this.props.handleSelect}
        />
      </div>
    );
  }
}

RatingControl.defaultProps = {
  rating: 0,
  size: 'default',
  useLibraryBranding: true
};

RatingControl.propTypes = {
  className: PropTypes.string,

  handleSelect: PropTypes.func,
  rating: PropTypes.number,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'extra-extra-small', 'extra-small', 'small', 'medium', 'large']),
  useLibraryBranding: PropTypes.bool
};

export default injectIntl(RatingControl);
